var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        bus: _vm.busModal,
        "max-width": "85vw",
        "center-screen": "",
        "content-class": "modal-release"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex flex-column",
          staticStyle: { "margin-top": "-40px", "margin-bottom": "24px" }
        },
        [
          _c("img", {
            staticStyle: { "margin-bottom": "12px" },
            attrs: {
              src: require("@assets/images/logo-partners.svg"),
              width: "230"
            }
          }),
          _vm.step === _vm.items.length - 1
            ? _c(
                "span",
                { staticClass: "text-paragraph-small text-color-900" },
                [
                  _vm._v(" Para saber mais sobre os serviços, clique "),
                  _c(
                    "a",
                    {
                      staticClass: "text-underline",
                      attrs: {
                        href: "mailto:gestao@aawz.com.br",
                        target: "_blank"
                      }
                    },
                    [_vm._v("aqui")]
                  ),
                  _vm._v(" para falar com um de nossos consultores. ")
                ]
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        { staticStyle: { position: "relative" } },
        [
          _c(
            "v-carousel",
            {
              staticStyle: { "max-height": "60vh" },
              attrs: { "show-arrows": false, "hide-delimiters": "" },
              model: {
                value: _vm.step,
                callback: function($$v) {
                  _vm.step = $$v
                },
                expression: "step"
              }
            },
            _vm._l(_vm.items, function(item) {
              return _c(
                "v-carousel-item",
                { key: item.title, staticStyle: { "min-height": "55vh" } },
                [
                  _c(
                    "h2",
                    { staticClass: "text-heading-large text-black mb-1rem" },
                    [_vm._v(" " + _vm._s(item.title) + " ")]
                  ),
                  item.description
                    ? _c(
                        "div",
                        {
                          staticClass: "text-color-900 text-paragraph-medium",
                          style: {
                            "max-width": item.img.length ? "90%" : "40%"
                          }
                        },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(item.description) }
                          })
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-items-center",
                      staticStyle: {
                        "flex-wrap": "wrap",
                        "max-height": "90%",
                        overflow: "auto",
                        padding: "10px",
                        gap: "0.8rem"
                      }
                    },
                    _vm._l(item.img, function(img) {
                      return _c("img", {
                        key: img,
                        staticClass: "elevation-1",
                        staticStyle: {
                          "max-width": "48%",
                          "border-radius": "6px",
                          "max-height": "40vh",
                          height: "auto",
                          width: "auto",
                          "min-height": "200px"
                        },
                        attrs: { src: img, alt: item.title }
                      })
                    }),
                    0
                  )
                ]
              )
            }),
            1
          ),
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center",
              staticStyle: {
                position: "absolute",
                bottom: "-10px",
                gap: "1rem",
                left: "0",
                right: "0",
                width: "fit-content",
                "margin-left": "auto",
                "margin-right": "auto"
              }
            },
            _vm._l(_vm.items, function(item, index) {
              return _c("div", {
                key: index,
                staticClass: "mouse-hover",
                class: { "bg-primary": index === _vm.step },
                style: {
                  "border-radius": "50px",
                  width: "12px",
                  height: "12px",
                  opacity: index === _vm.step ? 1 : 0.6,
                  "background-color": "#e4e4e4",
                  "z-index": 2
                },
                on: {
                  click: function($event) {
                    _vm.step = index
                  }
                }
              })
            }),
            0
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex align-items-center mt-5" },
        [
          _c("v-checkbox", {
            attrs: {
              label: "Não mostrar isso novamente",
              "hide-details": "",
              dense: ""
            },
            model: {
              value: _vm.dontShowAgain,
              callback: function($$v) {
                _vm.dontShowAgain = $$v
              },
              expression: "dontShowAgain"
            }
          }),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { text: "", color: "primary" },
              on: {
                click: function($event) {
                  _vm.step--
                }
              }
            },
            [
              _c("v-icon", { attrs: { color: "primary" } }, [
                _vm._v(" mdi-chevron-left ")
              ]),
              _vm._v(" Anterior ")
            ],
            1
          ),
          _c("div", { staticClass: "modal-release-divider" }),
          _c(
            "v-btn",
            {
              attrs: { text: "", color: "primary" },
              on: {
                click: function($event) {
                  _vm.step++
                }
              }
            },
            [
              _vm._v(" Próximo "),
              _c("v-icon", { attrs: { color: "primary" } }, [
                _vm._v(" mdi-chevron-right ")
              ])
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }